import "../project/project.css";
import Hero from "../project/Hero.jsx";
import Nav from "../general/nav.jsx";
import Footer from "../general/Footer.jsx";
// import { useScrollMemory } from "../hook/useScrollMemory.jsx";

export default function ProjetPage() {
  // Utiliser la mémoire de scroll pour la page projects
  // useScrollMemory("projects");

  return (
    <div className="projet-page">
      <Nav />
      <Hero />
      <Footer />
    </div>
  );
}
